import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { brand } from '../theme';
import { optimizedBackground } from '../utils/images';
import Logo from './Logo';

interface NavItem {
  label: string;
  to?: string;
  href?: string;
}

const navItems: NavItem[] = [
  { label: 'Start', to: '/' },
  { label: 'Team', to: '/team' },
  { label: 'Projekte', to: '/projects' },
  { label: 'Holz', to: '/wood' },
  { label: 'Instagram', href: 'https://www.instagram.com/holzbasteln' },
];

const linkProps = (item: NavItem) =>
  item.to ? { component: Link, to: item.to } : { component: 'a' as const, href: item.href };

const HamburgerIcon = () => (
  <Box component="svg" width={24} height={24} viewBox="0 0 24 24" aria-hidden="true" sx={{ fill: 'currentColor' }}>
    <rect x="3" y="6" width="18" height="2" rx="1" />
    <rect x="3" y="11" width="18" height="2" rx="1" />
    <rect x="3" y="16" width="18" height="2" rx="1" />
  </Box>
);

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundImage: `url(${optimizedBackground(brand.backgrounds.header, 960)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Toolbar sx={{ gap: 2 }}>
        <Box
          component={Link}
          to="/"
          aria-label="Werklibuebe – Startseite"
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, textDecoration: 'none', flexGrow: 1 }}
        >
          <Logo height={40} />
          <Typography
            variant="h6"
            component="span"
            sx={{ color: brand.orange, fontWeight: 700, letterSpacing: 1, display: { xs: 'none', sm: 'block' } }}
          >
            WERKLIBUEBE
          </Typography>
        </Box>

        {/* Desktop navigation */}
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
          {navItems.map((item) => (
            <Button key={item.label} color="inherit" {...linkProps(item)}>
              {item.label}
            </Button>
          ))}
        </Box>

        {/* Mobile navigation trigger */}
        <IconButton
          color="inherit"
          edge="end"
          aria-label="Menü öffnen"
          onClick={() => setOpen(true)}
          sx={{ display: { xs: 'inline-flex', md: 'none' } }}
        >
          <HamburgerIcon />
        </IconButton>
      </Toolbar>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 240 }} role="presentation" onClick={() => setOpen(false)}>
          <List>
            {navItems.map((item) => (
              <ListItem key={item.label} disablePadding>
                <ListItemButton {...linkProps(item)}>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Header;
